/** 代理报告-基础信息 */
export const POST_AGENT_REPORT_INFO = "/api/agent/quarterReport/basicInfo";
/** 代理报告-学习情况 */
export const POST_AGENT_REPORT_LEARNINGSITUATION = "/api/agent/quarterReport/learningSituation";
/** 代理报告-学习时长 */
export const POST_AGENT_REPORT_LEARNINGTIME = "/api/agent/quarterReport/learningTime";
/** 代理报告-词云 */
export const POST_AGENT_REPORT_WORDCLOUD = "/api/agent/quarterReport/wordCloud";
/** 代理报告-完课考试信息 */
export const POST_AGENT_REPORT_COURSEEXAMINFO = "/api/agent/quarterReport/courseExamInfo";
/** 代理报告-认证考试信息 */
export const POST_AGENT_REPORT_CERTEXAMINFO = "/api/agent/quarterReport/certExamInfoNew";
/** 代理报告-雷达图 */
export const POST_AGENT_REPORT_RADARCHAR = "/api/agent/quarterReport/radarChar";
/** 代理报告-表格 */
export const POST_AGENT_REPORT_TABLECHAR = "/api/agent/quarterReport/tableChar";
/** 代理报告-Top名单 */
export const POST_AGENT_REPORT_LEARNINGTOPLIST = "/api/agent/quarterReport/learningTopList";
/** 代理报告-线下培训统计 */
export const POST_AGENT_REPORT_OFFLINEDATA = "/api/agent/quarterReport/offlineData";
/** 代理报告-考试Top名单 */
export const POST_AGENT_REPORT_EXAM_TOPLIST = "/api/agent/quarterReport/examTopList";
/** 代理报告-sea第二页数据 */
export const POST_AGENT_REPORT_SEA_OFFLINE_DATA= "/api/agent/quarterReport/seaOfflineData";

//reportYear页 第三page统计
export const POST_AGENT_REPORT_CERT_PASS_NUM= "/api/agent/quarterReport/certPassNum";
